import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { BreadcrumbContainer, CustomBreadcrumbWrapper } from "./Breadcrumb.styled";

const DEFAULT_ITEMS = [
  { label: "User Manager", href: "/v2/user-management" },
  { label: "Users" },
];

const Breadcrumb = ({ items = DEFAULT_ITEMS }) => {
  const { pathname } = useLocation();

  return (
    <BreadcrumbContainer>
      <CustomBreadcrumbWrapper id="breadcrumb-wrapper">
        <DynamicBreadcrumbs 
          items={items} 
          currentPath={pathname}
        />
      </CustomBreadcrumbWrapper>
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

